(function () {
  function datePartsInTimeZone(timeZone) {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(new Date());
    var values = {};
    parts.forEach(function (part) {
      if (part.type !== 'literal') values[part.type] = Number(part.value);
    });
    return new Date(Date.UTC(values.year, values.month - 1, values.day, 12));
  }

  function addDays(date, days) {
    var result = new Date(date.getTime());
    result.setUTCDate(result.getUTCDate() + days);
    return result;
  }

  function render(root) {
    if (root.dataset.deliveryReady === 'true') return;

    var locale = root.dataset.locale || document.documentElement.lang || 'en';
    var timeZone = root.dataset.timeZone || 'Europe/Berlin';
    var minDays = Number(root.dataset.minDays || 5);
    var maxDays = Math.max(minDays, Number(root.dataset.maxDays || 10));
    var formatter = new Intl.DateTimeFormat(locale, {
      day: 'numeric',
      month: 'short',
      timeZone: 'UTC'
    });
    var berlinToday = datePartsInTimeZone(timeZone);

    root.querySelector('[data-delivery-min]').textContent = formatter.format(addDays(berlinToday, minDays));
    root.querySelector('[data-delivery-max]').textContent = formatter.format(addDays(berlinToday, maxDays));
    root.dataset.deliveryReady = 'true';
  }

  function initialize(container) {
    (container || document).querySelectorAll('[data-yeese-delivery-estimate]').forEach(render);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
